import React, { useEffect, useState  } from "react";
import axios from "axios";
import { MdExpandMore, MdOutlineDelete } from "react-icons/md";
import { giveTextColor } from "../../helpers/textColors";
import { RiMailSendLine } from "react-icons/ri";
import { FaEye } from "react-icons/fa";
import DynamicTooltip from "../../components/DynamicTooltip";
import SidePopup from "../../components/Popup/SidePopup";
import Popup from "../../components/Popup/Popup";
import MultiDropdown from "../../components/MultiDropdown";
//Shreshth Import
import constant from "../../constant/constant";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SmallLoader from "../../components/SmallLoader";
import { logout } from "../../store/authSlice.js";
import { ToastContainer, toast } from "react-toastify";
import SingleDropdown from "../../components/SingleDropdown";
import SearchInput from "../../components/SearchInput";
import Tooltip from "../../components/Tooltip";
import NoPermission from "../../components/NoPermission.js";
import NoData from "../../assets/No_data.png";

const StudentCourse = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth);
  const limit = 10;
  const [activeCourseIndex, setActiveCourseIndex] = useState(0);

  //Shreshth Const Start Here
  const [courseData, setCourseData] = useState([]);
  const [emailOptions, setEmailOptions] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [filterStatus, setFilterStatus] = useState(false);
  const [dataStatus, setDataStatus] = useState(false);
  const [userName, setUserName] = useState("");
  const [courseId, setCourseId] = useState("");
  const [workOrderId, setWorkOrderId] = useState("");
  const [courseName, setCourseName] = useState("");
  
  //Filter
  const [searchText, setSearchText] = useState("");
  const [searchLabel, setSearchLabel] = useState("Search by");
  const [searchBy, setSearchBy] = useState("");
  const [course, setCourse] = useState("");
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [clearSignal, setClearSignal] = useState(false);
  const [enrolledDataStatus, setEnrolledDataStatus] = useState(false);
  const pageRoleAccess = user.user_type;
  const searchByOptions = [
    { label: "Name", value: "name" },
    { label: "Email", value: "email" },
    { label: "Mobile", value: "mobile" },
  ];
  const [selectedPreferedBatch, setSelectedPreferedBatch] = useState("");
  const [preferedBatch, setPreferedBatch] = useState("");
  const [preferedBatchOptions, setPreferedBatchOptions] = useState([]);
  //Shreshth Const End Here


  const [studentInfoPopup, setStudentInfoPopup] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [addTeamPopup, setAddTeamPopup] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);

  const [listFilter, setListFilter] = useState(
    {
      "searchtext": "",
      "searchByOptions":"",
      "courseId": "",
    }
  );

  const applyFilter = async () => {
    let updatefilter = {
      ...listFilter,
      "searchtext": searchText,
      "searchByOptions": searchBy,
      "courseId": course,
    };
    setListFilter(updatefilter);
  };

  const handleNavigate = () => {
    navigate('/my-account?tab=course');
  };

  const handleCourseChange = (option) => {
    setCourse(option.value);
    setFiltersApplied(true);
  };
  const handleSearchChange = (value) => {
    setSearchText(value);
    setFiltersApplied(true);
  };

  const handleSearchByChange = (option) => {
    setSearchBy(option.value);
    setSearchLabel(option.label);
    setShowSearchInput(!!option.value);
    setFiltersApplied(true);
  };
  const handleClear = () => {
    setCourse("");
    setSearchBy("");
    setShowSearchInput(false);
    setClearSignal(true);
    let updatefilter = {
      ...listFilter,
      searchtext: "",
      searchByOptions: "",
      courseId: "",
    };
    setFiltersApplied(false);
    setListFilter(updatefilter);
  };
  const handlePreferedBatchSelect = (option) => {
    setPreferedBatch(option.value);
  };

  const toggleCourse = (index) => {
    setActiveCourseIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const handleStudentInfoPopupClose = () => {
    setStudentInfoPopup(false);
  };
  const getListRecordEnrolls = async () => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=getEnrolledStudentList`,
      headers: { "Auth-Id": user.auth_id },
      data: { filter: listFilter },
    })
    .then((response) => {
      if (response.data.data.status === "1") {
        setCourseData(response.data.data.data);
        setEnrolledDataStatus(true);
      }
    })
    .catch((error) => {
      console.error("Error during login:", error);
    })
  };
  const handleEmailsAccordingCourse = async (course_id, courseName, woId) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=getEmailForInvitation`,
      headers: {"Auth-Id": user.auth_id },
      data: {"course_id":course_id}
    }).then(function (response) {
      checkUserLogin(response);
      const responseData = response.data.data.data;
      if (response.data.data.status === "1") {
	      if (Array.isArray(responseData.email)) {
          setEmailOptions(responseData.email);
        }else {
          setEmailOptions([]);
        }
        if (Array.isArray(responseData.prefered_batch)) {
          setPreferedBatchOptions(responseData.prefered_batch);
        }else {
          setPreferedBatchOptions([]);
        }
      //  setEmailOptions(responseData.email);
       // setPreferedBatchOptions(responseData.prefered_batch);
        setCourseId(course_id);
        setWorkOrderId(woId);
        setCourseName(courseName);
        setAddTeamPopup(true);
      } else {        
        setCourseId(course_id);
        setWorkOrderId(woId);
        setCourseName(courseName);
        setAddTeamPopup(true);

      }
    })
    .catch(function (error) {
    });
  }

  const handleDelete = (user_id, work_order_id, course_id) => {
    statusRejectOfUser(user_id, work_order_id, course_id);
  };

  const statusRejectOfUser = async (student_id, work_order_id, course_id) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=statusEnrollRejectOfUser`,
      headers: {"Auth-Id": user.auth_id },
      data: {"student_id": student_id, "work_order_id":work_order_id, "course_id":course_id}
    }).then(function (response) {
      checkUserLogin(response);
      if (response.data.data.status === "1") {
        toast.success(response.data.data.msg);
        getListRecordEnrolls();
      } else {
        toast.warn(response.data.data.msg);
      }
    })
    .catch(function (error) {
    });
  }
  
  const handleSendInvitationAccordingCourse = async (course_id, selectedEmails, workOrderId, preferedBatch) => {
    if (!preferedBatch) {
      toast.warn("Please select prefered batch.");
      return;
    }
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=sendInvitationAccordingCourse`,
      headers: { "Auth-Id": user.auth_id },
      data: { course_id: course_id, selectedEmails: selectedEmails, workOrderId:workOrderId, prefered_batch:preferedBatch },
    })
      .then(function (response) {
        checkUserLogin(response);
        const responseData = response.data.data;
        if (Array.isArray(responseData.status) && Array.isArray(responseData.msg)) {
          responseData.status.forEach((status, index) => {
            const message = responseData.msg[index];
            if (status === "1") {
              toast.success(message);
            } else {
              toast.warn(message);
            }
          });
          setCourseId("");
          setCourseName("");
          setWorkOrderId("");
          setAddTeamPopup(false);
          getListRecordEnrolls();
        } else {
          toast.warn("Unexpected response format from the server.");
        }
      })
      .catch(function (error) {
        console.error("API error:", error);
        toast.error("An error occurred while sending invitations."); // General error handling
      });
  };

  const handleSendInvitationAgainAccordingCourse = async (course_id, student_id) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=handleSendInvitationAgainAccordingCourse`,
      headers: { "Auth-Id": user.auth_id },
      data: { course_id: course_id, student_id: student_id },
    })
      .then(function (response) {
        checkUserLogin(response);
        const responseData = response.data.data;
        if (Array.isArray(responseData.status) && Array.isArray(responseData.msg)) {
          responseData.status.forEach((status, index) => {
            const message = responseData.msg[index];
            if (status === "1") {
              toast.success(message);
            } else {
              toast.warn(message);
            }
          });
          setCourseId("");
          setCourseName("");
          setWorkOrderId("");
          setAddTeamPopup(false);
          getListRecordEnrolls();
        } else {
          toast.warn("Unexpected response format from the server.");
        }
      })
      .catch(function (error) {
        console.error("API error:", error);
        toast.error("An error occurred while sending invitations."); // General error handling
      });
  };
  
  const closeAddTeamPopup = () => {
    setCourseId("");
    setCourseName('');
    setWorkOrderId("");
    setAddTeamPopup(false);
    setPreferedBatch("");
    // setEditedMember(null);
  };
  
  const handleSelectEmail = (value) => {
    setSelectedEmails((prevSelected) => {
      const index = prevSelected.indexOf(value);
      const updatedValues = [...prevSelected];

      if (index === -1) {
        updatedValues.push(value);
      } else {
        updatedValues.splice(index, 1);
      }
      return updatedValues;
    });
  };
  
  const handleAddNewEmailOption = async (newEmail) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(newEmail)) {
      toast.warn("Please enter a valid email address.");
      return;
    }
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=addEmailForNewStudent`,
      headers: {"Auth-Id": user.auth_id },
      data: {"newEmail":newEmail}
    }).then(function (response) {
      checkUserLogin(response);
      const responseData = response.data.data.data;
      if (response.data.data.status === "1") {
        setSelectedEmails((prevSelected) => {
          if (!prevSelected.includes(newEmail)) {
            return [...prevSelected, newEmail];
          }
          return prevSelected;
        });
        toast.success(response.data.data.msg);
      } else if (response.data.data.status === "0") {
        toast.warn(response.data.data.msg);
      }
    })
    .catch(function (error) {
    });
    
  }
  const getAllEnrolledFilters = async () => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=getAllEnrolledFilters`,
      headers: {"Auth-Id": user.auth_id },
      data: {}
    }).then(function (response) {
      checkUserLogin(response);
      const responseData = response.data.data.data;
      if (response.data.data.status === "1") {
        setCourseOptions(responseData.courseData);
      }
    })
    .catch(function (error) {
    });
  }


  const checkUserLogin = (response) => {
    if (response.data.login.status === 0) {
      dispatch(logout());
      navigate("/login");
    }
  };

  useEffect(() => {
    getListRecordEnrolls();
  },[listFilter]);

  useEffect(() => {
    getAllEnrolledFilters();
  },[]);

  return (
    <>
    {pageRoleAccess === "company" ? ( 
      enrolledDataStatus == true ? (
        <>
          <div className="course-container lings-container df mr20 settings">
            <div className="w100">
              <div className="account-details df fdc">
                <div className="settings-head st-crs">
                  <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                    Track the progress, enrollment details, and statuses of students
                    from your team enrolled in various courses
                  </div>
                </div>
              </div>
              <div className="student-filter mt16 v-center fww brd-b1 pb24">
                {courseOptions?.length > 0 && (
                  <div className="course-filter mr12">
                    <SingleDropdown
                      label="Select Course"
                      options={courseOptions}
                      selectedOption={courseOptions.find(
                        (option) => option.value === course
                      )}
                      onSelect={handleCourseChange}
                      noLabel={false}
                    />
                  </div>
                )}
                {courseOptions?.length > 0 && (
                  <div className="search-by-filter mr12">
                    <SingleDropdown
                      label="Search by"
                      options={searchByOptions}
                      selectedOption={searchByOptions.find(
                        (option) => option.value === searchBy
                      )}
                      onSelect={handleSearchByChange}
                      noLabel={false}
                    />
                  </div>
                )}
                {showSearchInput && (
                  <div className="search-filter v-center mt8 mr12">
                    <SearchInput
                      onSearchChange={handleSearchChange}
                      clearSignal={clearSignal}
                      placeholder={searchLabel}
                    />
                  </div>
                )}
                {filtersApplied && (
                  <>
                    <button
                      className="bg3 fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 mr8 mt8"
                      onClick={applyFilter}
                    >
                      GO
                    </button>
                    <button
                      className="clear fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 fw6 mt8"
                      onClick={handleClear}
                    >
                      Clear
                    </button>
                  </>
                )}
              </div>
              <div>
                {courseData.length > 0 ? (
                  courseData.map((course, courseIndex) => (
                    <div key={courseIndex}>
                      <div
                        className={`bill-head df aic jcsb pt24 pb16 ${
                          courseIndex !== 0 ? "brd-t2" : ""
                        }`}
                        onClick={() => toggleCourse(courseIndex)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="mb16 flx75">
                          <p className="fs14 fc8 ls1 lh22 fw6 v-center">
                            {course.courseName} ({course.woId})
                            <span className="fs14 fc5 ls1 lh22 fw6 mr16 v-center">
                              <MdExpandMore
                                className={`fs20 ${
                                  activeCourseIndex === courseIndex ? "rotate-180" : ""
                                }`}
                              />
                            </span>
                          </p>
                          <p className="fs14 fc16 fw4 fc6 lh18 mt4">{course.description}</p>
                        </div>
                        <div
                          className="v-center pending-amt cp"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEmailsAccordingCourse(
                              course.course_id,
                              course.courseName,
                              course.woId
                            );
                          }}
                        >
                          {Number(course.course_inventory) > Number(course.course_consumed_inventory) && (
                          <div className="myteam-button v-center jce flx1">
                            <button
                              className="btn-blue ls1"
                            >
                              Send Invitation
                            </button>
                          </div>
                          )}
                        </div>
                      </div>

                      {activeCourseIndex === courseIndex && (
                        <div
                          className="joinde-course-list pb24 "
                          style={{ overflow: "auto" }}
                        >
                          {course.students.length > 0 && (
                          <table className="w100 tac wsnw">
                            <thead>
                              <tr>
                                <th>
                                  <p className="box-center">Name</p>
                                </th>
                                <th>
                                  <p className="box-center">Email</p>
                                </th>
                                <th>
                                  <p className="box-center">Attendance</p>
                                </th>
                                <th>
                                  <p className="box-center">Theory Batch</p>
                                </th>
                                <th>
                                  <p className="box-center">Flying Batch</p>
                                </th>
                                <th>
                                  <p className="box-center">Start Date</p>
                                </th>
                                <th>
                                  <p className="box-center">End Date</p>
                                </th>
                                <th>
                                  <p className="box-center">Status</p>
                                </th>
                                <th>
                                  <p className="box-center">Action</p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {course.students.map((student, studentIndex) => {
                                const [present, total] = student.attendance.split("/");
                                return (
                                  <tr key={studentIndex}>
                                    <td>{student.name}</td>
                                    <td>{student.email}</td>
                                    <td className="ls2 ">
                                      <DynamicTooltip
                                        direction="bottom"
                                        text="Classes Attended"
                                      >
                                        <span
                                          style={{
                                            color: "#7bbc7c",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {present}
                                        </span>
                                      </DynamicTooltip>
                                      /
                                      <DynamicTooltip
                                        direction="bottom"
                                        text="Total Classes "
                                      >
                                        <span
                                          style={{
                                            color: " #313131",
                                          }}
                                        >
                                          {total}
                                        </span>
                                      </DynamicTooltip>
                                    </td>
                                    <td>{student.batch}</td>
                                    <td>{student.fly_batch}</td>
                                    <td>{student.startDate}</td>
                                    <td>{student.endDate}</td>
                                    <td style={{textTransform: "capitalize"}}>
                                      
                                      {student.status}

                                    </td>
                                    <td>
                                      {student.courses.length > 0 && (
                                        <DynamicTooltip direction="bottom" text="View ">
                                          <FaEye
                                            className="mr8 fs18 fc6 cp pt8 pb8 "
                                            onClick={() => {
                                              setSelectedStudent(student);
                                              setStudentInfoPopup(true);
                                            }}
                                          />
                                        </DynamicTooltip>
                                      )}

                                     
                                      {(student.status == "Invitation Declined" || student.status == "Invited") && (
                                        <>
                                          <DynamicTooltip
                                            direction="bottom"
                                            text="Resend"
                                          >
                                            <RiMailSendLine 
                                              className="mr8 fs18 fc6 cp pt8 pb8 pl4" 
                                              onClick={() => handleSendInvitationAgainAccordingCourse(student.course_id, student.student_id)}
                                            />
                                          </DynamicTooltip>
                                          <DynamicTooltip
                                            direction="bottom"
                                            text="Delete"
                                          >
                                            <MdOutlineDelete 
                                              className="fs20 fc6 cp pt8 pb8 pr8"
                                              onClick={() => handleDelete(student.student_id, course.work_order_id, course.course_id)}
                                            />
                                          </DynamicTooltip>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
			  )}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="fs16 fc8 tac mt16">No Records Found</p>
                )}
                {studentInfoPopup && selectedStudent && (
                  <SidePopup
                    show={studentInfoPopup}
                    onClose={handleStudentInfoPopupClose}
                    className="full-width"
                  >
                    <div className="selected-plan-details">
                      <div className="df jcsb profile-card-header brd-b1 p12 box-center bg7 w100 fc1 ls2 lh22">
                        <p className="fs18 fc3">{`${selectedStudent.name}'s Course History`}</p>
                        <button
                          onClick={() => {
                            handleStudentInfoPopupClose();
                            document.body.style.overflow = "auto";
                          }}
                          className="lead-close-button"
                        >
                          X
                        </button>
                      </div>

                      <div className="booked p8">
                        <table className="ledger-table cp w100 wsnw">
                          <thead>
                            <tr>
                              <th>Course Name</th>
                              <th>Theory Batch</th>
                              <th>Flying Batch</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Training Center</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedStudent.courses &&
                            selectedStudent.courses.length > 0 ? (
                              selectedStudent.courses.map((course, index) => (
                                <tr key={index}>
                                  <td>{course.course_name}</td>
                                  <td>{course.batch}</td>
                                  <td>{course.fly_batch}</td>
                                  <td>{course.startDate}</td>
                                  <td>{course.endDate}</td>
                                  <td>{course.training_center}</td>
                                  <td style={{textTransform: "capitalize"}}>
                                    {course.status}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="6"
                                  style={{ textAlign: "center", padding: "12px" }}
                                >
                                  No Course is available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </SidePopup>
                )}
                {addTeamPopup && (
                  <Popup
                    onClose={closeAddTeamPopup}
                    title={"Send Invitation"}
                    txtSubHeading={`Enter the student’s email to enroll them in our ${courseName}.`}
                  >
                    <div className="form-group-settings course-name cm-fr searching-drop st-cr">
                      <div className="">
                        <div className="">
                          <p className="fc15 fw6 fs14 ls1 mb8">Email Address(es)</p>
                          <MultiDropdown
                            label={`Emails`}
                            options={emailOptions}
                            selectedValues={selectedEmails}
                            onSelect={handleSelectEmail}
                            onAddNewOption={handleAddNewEmailOption}
                            searchable
                            chips="8"
                          />
                        </div>
                        <div className="mt12">
                          <SingleDropdown
                            label="Perfered Batch"
                            options={preferedBatchOptions}
                            selectedOption={preferedBatchOptions.find(
                              (option) => option.value === preferedBatch
                            )}
                            onSelect={handlePreferedBatchSelect}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="button-container mt32 df jce brd-t1 pt12">
                      <button
                        type="button"
                        className="btn-cancel"
                        onClick={closeAddTeamPopup}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="update-button btn-blue ls1 pt10 pb10 pl12 pr12 br24 cp"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSendInvitationAccordingCourse(
                            courseId,
                            selectedEmails,
                            workOrderId,
                            preferedBatch

                          );
                        }}
                      >
                        Send Invite
                      </button>
                    </div>
                  </Popup>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <img src={NoData} className="no-data-img" alt="No data"/>
          <p className="fs16 fc8 tac">No record available. <span className="cp fc3 tdu" onClick={handleNavigate}>Purchase</span> course to invite colleagues.</p>
        </>
      )
    ) : (
      <NoPermission displayMsg={"No permission to access this page"} />
    )}  
    <ToastContainer position="bottom-right" />
    </>
  );
};

export default StudentCourse;
